import { gql } from "@apollo/client";


export const GET_ADS_TXT_DATA = gql`
query Query($input: getAdsTxtInput!) {
  getAdsTxt(input: $input)
}
`